import React from 'react';
import './PromptHierarchy.css';

const formatDate = (dateStr) => {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
};

const PromptHierarchy = ({ onPromptClick, prompts, onTabChange }) => {
  // Найти промпт по имени
  const findPrompt = (name) => {
    return prompts.find(p => p.name === name);
  };

  const getVersionInfo = (name) => {
    const prompt = findPrompt(name);
    if (!prompt) return '';
    const parts = [];
    if (prompt.active_version) parts.push(`v${prompt.active_version}`);
    if (prompt.updated_at) parts.push(formatDate(prompt.updated_at));
    return parts.length > 0 ? ` (${parts.join(' / ')})` : '';
  };

  const handlePromptClick = (name) => {
    const prompt = findPrompt(name);
    if (prompt && onPromptClick) {
      onPromptClick(prompt);
    }
  };

  const handleNavigateToClassifier = () => {
    if (onTabChange) {
      onTabChange('classes');
    }
  };

  const handleNavigateToKnowledgeBase = () => {
    if (onTabChange) {
      onTabChange('qa');
    }
  };

  return (
    <div className="prompt-hierarchy">
      {/* Основной системный промпт */}
      <div className="hierarchy-level">
        <div
          className="hierarchy-box clickable"
          onClick={() => handlePromptClick('main')}
        >
          Основной системный промпт{getVersionInfo('main')}
        </div>
      </div>

      <div className="hierarchy-arrow">↓</div>

      {/* Стиль */}
      <div className="hierarchy-level">
        <div
          className="hierarchy-box clickable"
          onClick={() => handlePromptClick('style')}
        >
          Стиль{getVersionInfo('style')}
        </div>
      </div>

      <div className="hierarchy-arrow">↓</div>

      {/* Контекст диалога */}
      <div className="hierarchy-level">
        <div className="hierarchy-box info-box">
          Контекст диалога: чек-лист, диалог, интерес
        </div>
      </div>

      <div className="hierarchy-arrow">↓</div>

      {/* Разветвление */}
      <div className="hierarchy-level split-level">
        <div className="split-container">
          <div
            className="hierarchy-box clickable small-box"
            onClick={handleNavigateToClassifier}
          >
            Промт агента
          </div>

          <div className="hierarchy-box small-box disabled">
            Таблица UTM
          </div>
        </div>
      </div>

      <div className="hierarchy-arrow split-arrow">
        <span>↓</span>
        <span>↓</span>
      </div>

      {/* База знаний */}
      <div className="hierarchy-level">
        <div
          className="hierarchy-box clickable"
          onClick={handleNavigateToKnowledgeBase}
        >
          База знаний
        </div>
      </div>
    </div>
  );
};

export default PromptHierarchy;
